module.exports = {"231002001":"新安街道","231002002":"长安街道","231002003":"七星街道","231002004":"五星街道","231002008":"东兴街道","231002009":"振兴街道","231002101":"兴隆镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231002.json
// module id = 870
// module chunks = 0